export enum TerminTyp {
    URLAUB = 'URLAUB',
    VORORT = 'VORORT',
    EXTERN = 'EXTERN',
}
